var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueElipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 594,
    viewBox: "0 0 594 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 297,
    r: 297,
    fill: "#0021F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueElipse);
export default __webpack_public_path__ + "static/media/BlueElipse.651c731861418793c2164e50c9e51ba1.svg";
export { ForwardRef as ReactComponent };